import React, { FC, useEffect } from 'react';
import { ActivityTimeline } from '../orders/ActivityTimeline';
import { Spinner } from '../Spinner';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { fetchApplicationDetailsLogs } from '../../store/merchnts/actions/application';

export const ApplicationDetailActivityLogsModal: FC<{ id: string }> = ({ id }) => {

  const { merchantState, dispatch } = useMerchants();
  const { applicationDetailsLogs, isApplicationDetailsLogsLoading } = merchantState;


  useEffect(() => {
    void fetchApplicationDetailsLogs({ dispatch, applicationId: id });
  }, []);

  // const groupByDate = applicationDetailsLogs?.reduce((group, item, index) => {
  //   const date = getFormattedDate(item.createdOn, 'yyyy-MM-dd') as string;
  //   if (!group[date]) {
  //     group[date] = [{ ...item, id: index + 1 }];
  //   } else {
  //     group[date].push({ ...item, id: index + 1 });
  //   }
  //   return group;
  // }, {});

  const newActivityList = applicationDetailsLogs?.map((item, index) => ({ ...item, id: index + 1 }));

  // const timeLineBody = Object.keys(groupByDate ?? {})?.length > 1
  //   ? (
  //     Object.keys(groupByDate || {})?.map((key): JSX.Element => (
  //       <ActivityLogSection
  //         key={key}
  //         date={key}
  //         data={groupByDate[key]}
  //       />
  //     ))
  //   )
  //   : (
  //     <ActivityTimeline
  //       activityList={newActivityList}
  //     />
  //   );

  return (
    <div className="px-8">
      {
        isApplicationDetailsLogsLoading
          ? <Spinner pageLoader={true} />
          : <ActivityTimeline
            activityList={newActivityList}
          />
      }
    </div>
  );
};